module.exports = new __parcel__URL__("status-default.23d0a073.svg").toString();